import { combineReducers } from 'redux';

import LoginReducer from './LoginReducer';
import SignUpReducer from './SignUpReducer';
import VideoTopicsReducer from './VideoReducer';
import FlashCardReducer from './FlashReducer';
import QuestionReducer from './QuestionReducer';
import DashBoardReducer from './DashBoardReducer';
import SimulatedTestReducer from './SimulatedTestReducer';
import CardPurchaseReducer from './CardPurchaseReducer';
import ChallengeReducer from './ChallengeReducer';

import * as AchievementConstants from '../../shared/constants/AchievementConstants';

import {
  ACHIEVEMENT_UNLOCKED,
  HIDE_WELCOME_SCREEN,
  LOGIN,
  LOGIN_REQUEST,
  LOGOUT,
  SAVE_PURCHASE_STATUS,
  SHOW_LOGIN,
  SHOW_WELCOME_SCREEN,
  START_LOADING,
  STOP_LOADING,
  UPDATE_ACHIEVEMENT_DETAILS,
} from '../actions/ActionTypes';

import { REHYDRATE } from 'redux-persist';

const initialCommonState = {
  userId: null,
  emailId: null,
  sessionToken: null,
  access_token: null,
  totalCards: null,
  listOfCards: [],
  isLoading: false,
  welcomeScreenVisible: true,
  internetAlert: 0,
  showLogin: false,
  purchaseStatus: false,

  when_50_flashcards: 0,
  all_cards_count: 0,
  firstCardViewed: false,

  firstQuestionAnswered: false,
  firsrQuestionCorrectlyAnswered: false,
  allquestionsAnswered: 0,
  when_25_questionsAnswered: 0,

  firstSimulatedTest: false,
  secondSimulatedTest: false,

  showCarousalScreen: true,

  unlockedAchievementArray: [false, false, false, false, false, false, false],
};

const initialLoadingState = {
  isLoading: false,
};

const CommonReducer = (state = { ...initialCommonState }, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
      };

    case SHOW_LOGIN:
      return {
        ...state,
        showLogin: true,
      };

    case LOGIN:
      return {
        ...state,
        userId: action.userId,
        emailId: action.emailId,
        sessionToken: action.sessionToken,
        access_token: action.sessionToken,
        unlockedAchievementArray: action.unlockedAchievementArray,
      };
    case LOGOUT:
      return {
        ...state,
        userId: null,
        emailId: null,
        sessionToken: null,
        access_token: null,
        ...initialCommonState,
      };

    // case UPDATE_ACHIEVEMENT_DETAILS:

    // return {
    //   ...state,
    //   firstCardViewed: true,
    // };
    case UPDATE_ACHIEVEMENT_DETAILS: // update state of achievements in the app
      let flash_start = action.data.filter((achievement) => {
        // achievement of first flash card viwed, syncing with server
        return (
          achievement.achievement_type ===
          AchievementConstants.achievementName_1
        );
      });

      let mcq_start = action.data.filter((achievement) => {
        // achievement of first question answered , syncing with server
        return (
          achievement.achievement_type ===
          AchievementConstants.achievementName_3
        );
      });

      let mcq_one_correct = action.data.filter((achievement) => {
        // achievement of first question answered correctly , syncing with server
        return (
          achievement.achievement_type ===
          AchievementConstants.achievementName_4
        );
      });

      let test_1_complete = action.data.filter((achievement) => {
        // achievement of first simulated test, syncing with server
        return (
          achievement.achievement_type ===
          AchievementConstants.achievementName_6
        );
      });

      let test_2_complete = action.data.filter((achievement) => {
        // achievement of second simulated test, syncing with server
        return (
          achievement.achievement_type ===
          AchievementConstants.achievementName_7
        );
      });

      return {
        ...state,
        firstCardViewed: flash_start.length > 0 && flash_start[0].status,
        firstQuestionAnswered: mcq_start.length > 0 && mcq_start[0].status,
        firsrQuestionCorrectlyAnswered:
          mcq_one_correct.length > 0 && mcq_one_correct[0].status,
        firstSimulatedTest:
          test_1_complete.length > 0 && test_1_complete[0].status,
        secondSimulatedTest:
          test_2_complete.length > 0 && test_2_complete[0].status,
      };
    case ACHIEVEMENT_UNLOCKED: {
      return {
        ...state,
        [action.achievement_key]: action.value,
      };
    }
    case SAVE_PURCHASE_STATUS:
      return {
        ...state,
        purchaseStatus: action.purchaseStatus,
      };

    /******* welcome screen  *******/

    case SHOW_WELCOME_SCREEN:
      return {
        ...state,
        welcomeScreenVisible: true,
      };
    case HIDE_WELCOME_SCREEN:
      return {
        ...state,
        welcomeScreenVisible: false,
      };

    /********************************/
    case REHYDRATE:
      return {
        ...state,
        ...(action.payload || {}).CommonReducer,
      };
    default:
      return state;
  }
};

const LoadingReducer = (state = { ...initialLoadingState }, action) => {
  switch (action.type) {
    case START_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case STOP_LOADING:
      return {
        ...state,
        isLoading: false,
      };

    case REHYDRATE:
      return {
        ...state,
        ...(action.payload || {}).LoadingReducer,
      };
    default:
      return state;
  }
};

const Reducers = combineReducers({
  CommonReducer,
  LoginReducer,
  SignUpReducer,
  LoadingReducer,
  VideoTopicsReducer,
  FlashCardReducer,
  QuestionReducer,
  DashBoardReducer,
  SimulatedTestReducer,
  CardPurchaseReducer,
  ChallengeReducer,
});

export default Reducers;
